import type { TLocalize } from '@hooks/use-localize';
import type { INkrCenterOption } from '@/types/history/nkr-centers';

interface IProps {
    center: INkrCenterOption;
    t: TLocalize;
    isSubmitting: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

const CenterSelectModals = ({ center, t, isSubmitting, onConfirm, onClose }: IProps) => {
    const body = center.hasSoftErrors ? (
        <div className="modal-body">
            <p>
                Based on the details you&apos;ve provided, you do not appear to be eligible to apply
                at this center.
            </p>
            <p>
                If your status has changed since your initial registration, you may override this
                block by confirming the below statement(s) are true:
            </p>
            <ul>
                {center.overrideConfirmations.map((confirmation, index) => (
                    <li key={index}>{confirmation}</li>
                ))}
            </ul>
        </div>
    ) : (
        <div className="modal-body">
            <p>
                {t('DashLabel_AreYouSureYouWishToSelect', 'Are you sure you wish to select')}{' '}
                <strong>{center.name}</strong>?{' '}<br /><br />
                {t('DashLabel_OnceSelectedThereIsNoWayToChangeIt', 'Once selected, there is no way to change it.')}
            </p>
        </div>
    );

    const confirmLabel = center.hasSoftErrors
        ? 'I confirm statement(s) are true'
        : t('Word_Continue', 'Continue');

    return (
        <Modal title="Please Confirm" onClose={onClose}>
            {body}
            <div className="modal-footer">
                <div className="row">
                    <div className="col-xs-12 col-sm-6 col-sm-offset-3 xsonly-padtop">
                        <button
                            type="button"
                            className="btn btn-nkr-red col-xs-12"
                            disabled={isSubmitting}
                            onClick={onConfirm}
                        >
                            {confirmLabel}
                        </button>
                    </div>
                    <div className="col-xs-12 col-sm-3">
                        <button
                            type="button"
                            className="btn btn-default col-xs-12"
                            disabled={isSubmitting}
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

interface IModalProps {
    title: string;
    onClose: () => void;
    children: React.ReactNode;
}

const Modal = ({ title, onClose, children }: IModalProps) => (
    <div className="modal fade in" tabIndex={-1} role="dialog" style={{ display: 'block' }}>
        <div className="modal-dialog" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h4 className="modal-title">{title}</h4>
                </div>
                {children}
            </div>
        </div>
    </div>
);

export default CenterSelectModals;
